module.exports = __webpack_public_path__ + "img/saven_logo.017bb7cb.png";